import type { Dictionary } from '../types';

// English is the template's default/source language, so these values match
// the strings already hardcoded in `src/content/*.ts` exactly — selecting
// "English" never changes what a buyer already sees out of the box.
export const en: Dictionary = {
    'nav.home': 'Home',
    'nav.about': 'About Us',
    'nav.origins': 'Global Origins',
    'nav.products': 'Products',
    'nav.quality': 'Quality',
    'nav.contact': 'Contact Us',
    'language.label': 'Language',
};

export default en;
